import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';

@Component({
  selector: 'app-pdflandingpage',
  templateUrl: './pdflandingpage.component.html'
})
export class PdflandingpageComponent implements OnInit {

  constructor(private commonDataService: CommonDataService, private grpahqlservice: GraphqlService) { }
  pdflistdata
  TOC_pageHeader
  TOC_Subdesc
  TOC_Subtitle
  ngOnInit(): void {
    this.grpahqlservice.getTOClinks().subscribe(data => {
      this.pdflistdata = data.content.data.pdF_Items
    })
    this.grpahqlservice.getTOClabels().subscribe(data => {
      var labels = data.content.data.labels
      labels = labels.filter(x => x.key.trim());
      this.TOC_pageHeader = labels.filter(x => x.key == "TOC_pageHeader").map(y => y.value);
      this.TOC_Subdesc = labels.filter(x => x.key == "TOC_Subdesc").map(y => y.value);
      this.TOC_Subtitle = labels.filter(x => x.key == "TOC_Subtitle").map(y => y.value);

    })
  }
  Open(event , pdfName) {
    event.preventDefault();
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("pdfviewer");
    this.commonDataService.rightPanelWidth.next("rightOverlay_ex_large");
    this.commonDataService.closeModalOption.next(true);
    this.commonDataService.closeandActionOption.next(false);
    this.commonDataService.pdfName.next(pdfName);
    this.commonDataService.tcprint.next(true);
  }
  onRightClick(event, data?: any) {
    if (data != null) {
      if ((data.includes('.')) && (data.split('.').pop() === 'pdf')) {
        let url = "";
        url = '/layoutComponents/getPdf?isSitesBucket=' + true + '&fileName=' + data;//show pdf
        event.srcElement.setAttribute('href', url);
      }
    }
  }
}
